<template>
  <div
    class="applicant-item"
  >
    <div class="item-idphoto">
      <img
        class="idphoto-img"
        :src="
          applicantItem.dest_photo ||
            'https://o.666visa.cn/static/ssqwxa/historical-applicant/applicant-default-2x.png'
        "
        alt=""
      />
    </div>
    <div class="item-body">
      <div class="one-row">
        <div class="applicant-name" :title="applicantItem.applicant_name">{{ applicantItem.applicant_name }}</div>
        <div class="applicant-identity">
          {{ applicantItem.identity_id === 5 ? '通用身份' : APPLICANT_IDENTITY_MAP[applicantItem.identity_id] }}
        </div>
      </div>
      <div class="two-row">
        <div class="applicant-passport">
          护照号码：{{ getShowPassportNumber(applicantItem.passport_number) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APPLICANT_IDENTITY_MAP } from '@/maps/applicant-maps';

export default {
  components: {},
  props: {
    applicantItem: Object,
  },
  data() {
    return {
      APPLICANT_IDENTITY_MAP,
    };
  },
  computed: {},
  created() {},
  methods: {
    // 获取显示的护照号，加*
    getShowPassportNumber(passport_number) {
      if (passport_number && passport_number.length > 3) {
        const middle = Math.floor(passport_number.length / 2);
        passport_number = `${passport_number.substring(
          0,
          middle - 1,
        )}***${passport_number.substring(middle + 2)}`;
      }
      return passport_number;
    },
  },
};
</script>

<style lang="less" scoped>
.applicant-item {
  width: 240px;
  display: flex;
  align-items: flex-start;
  border: 1px solid #E9EEF2;
  border-radius: 2px;
  margin-right: 60px;
  margin-bottom: 16px;
  padding: 8px;
  .item-idphoto {
    flex-shrink: 0;
    margin-right: 16px;
    .idphoto-img {
      width: 43px;
      height: 56px;
      object-fit: contain;
    }
  }
  .item-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .one-row {
      display: flex;
      align-items: center;
      .applicant-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #2f333d;
        font-size: 14px;
        line-height: 20px;
      }
      .applicant-identity {
        flex-shrink: 0;
        margin-left: 8px;
        background: #f7f8fa;
        height: 20px;
        padding: 0 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5f666e;
        font-size: 12px;
        line-height: 1;
      }
    }
    .two-row {
      margin-top: 8px;
      .applicant-passport {
        color: #91999f;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/history-applicant/components/history-applicant-item.vue